import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-report-pdf';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentReportPdfEffects {

    IncidentReportPdf$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_REPORT_PDF),
        mergeMap((x: ac.GetIncidentReportPdfAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentReportPdf(x.incident_id, x.reportVersion).pipe(
                map((result: any) => {
                    return new ac.GetIncidentReportPdfErfolgreichAction(result, x.incident_id, x.reportVersion, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentReportPdfFehlerAction(error, x.incident_id, x.reportVersion, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsReportingService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsReportingService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsReportingService);
        }
        return this.service;
    }
}
